<template>
  <div>
    <svg
      v-for="svg in items?.filter((t) => t.svgIcon)"
      :id="'svg_' + svg.id"
      :key="svg"
      width="21"
      height="21"
      style="align-self: center; margin-right: 3px"
    >
      <path :d="svg.svgIcon" />
    </svg>
    <MenuComponent
      :items="items"
      :select="onSelect"
      :before-item-render="onBeforeItemRender"
    />
  </div>
</template>

<script setup lang="ts">
import { MenuComponent } from "@syncfusion/ej2-vue-navigations";
import { SogDropDownButtonType } from "@/shared/ui/types/SogDropDownButtonType";
import SogMenuItem from "@/shared/ui/types/SogMenuItem";

interface Props {
  mdiIcon?: string;
  items?: SogMenuItem[];
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  mdiIcon: "",
  items: undefined,
  type: SogDropDownButtonType.Default,
});
const _emit = defineEmits<{ (e: "select", item?: SogMenuItem): void }>();

function onSelect(args: any) {
  _emit("select", args.item);
}

function onBeforeItemRender(args: any) {
  const a = document.getElementById("svg_" + args.item.id);

  const div = document.createElement("div");
  /*
    div.setAttribute("class", "sog-card-action-more-button");
  */
  div.setAttribute("style", "display:flex; ");

  if (a) {
    div.appendChild(a);
  }
  const text = document.createElement("span");
  text.innerText = args.item.text;
  div.appendChild(text);
  args.element.innerHTML = args.element.innerHTML.replace(args.item.text, "");
  args.element.appendChild(div);
  //  console.log(args.element)
}
</script>

<style scoped></style>
